import { useState } from 'react';
import { Menu, X } from 'lucide-react';

interface HeaderProps {
  onNavigateToAdmin?: () => void;
  onNavigateToAllEpisodes?: () => void;
}

export default function Header({ onNavigateToAdmin, onNavigateToAllEpisodes }: HeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navLinks = [
    { label: 'Home', href: 'home' },
    { label: 'Episodes', href: 'episodes', allEpisodes: true },
    { label: 'Apply', href: 'podcast-application' },
    { label: 'Coming Soon', href: 'news' },
    { label: 'About', href: 'about' },
    { label: 'Join W.F.P.', href: 'join-wfp' },
    { label: 'Login', href: 'admin', admin: true },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b" style={{ borderImageSource: 'linear-gradient(90deg, #ffde59, #ff39e5)', borderImageSlice: 1 }}>
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img
              src="/yok_logo_128.png"
              srcSet="/yok_logo_128.png 1x, /yok_logo_256.png 2x"
              alt="yOKzONa Logo"
              className="w-16 h-16"
              width="64"
              height="64"
            />
            <div className="flex flex-col items-center">
              <h1 className="font-barlow-condensed text-white text-3xl leading-none">
                yOKzONa
              </h1>
              <p className="text-white text-1xl" style={{ fontFamily: 'Nunito Sans, sans-serif' }}>
                Dev | AI | Games
              </p>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => {
                  if (link.external) {
                    window.open(link.external, '_blank');
                  } else if (link.admin && onNavigateToAdmin) {
                    onNavigateToAdmin();
                  } else if (link.allEpisodes && onNavigateToAllEpisodes) {
                    onNavigateToAllEpisodes();
                  } else {
                    scrollToSection(link.href);
                  }
                }}
                className="text-white hover:text-red-500 transition-colors font-semibold relative group"
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-red-500 transition-all group-hover:w-full"></span>
              </button>
            ))}
          </nav>

          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 border-t pt-4" style={{ borderImageSource: 'linear-gradient(90deg, #ffde59, #ff39e5)', borderImageSlice: 1 }}>
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => {
                    if (link.external) {
                      window.open(link.external, '_blank');
                    } else if (link.admin && onNavigateToAdmin) {
                      onNavigateToAdmin();
                    } else if (link.allEpisodes && onNavigateToAllEpisodes) {
                      onNavigateToAllEpisodes();
                    } else {
                      scrollToSection(link.href);
                    }
                  }}
                  className="text-white hover:text-red-500 transition-colors font-semibold text-left"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}